import formatCaseData from './formatCaseData';
import formatClientData from './formatClientData';
import formatReferralData from './formatReferralData';
import { MEDICAID_ID_LABEL, MODELS } from '../constants';

const { contact, referral, servicecase } = MODELS;

function getColumnHeaders(model) {
  switch (model) {
    case contact: {
      const headers = [
        { label: 'Client Name', value: 'full_name' },
        { label: MEDICAID_ID_LABEL, value: 'external_id' },
        { label: 'Phone', value: 'phone' },
        { label: 'DOB', value: 'dob' },
        { label: 'Location', value: 'location' },
        { label: 'Email', value: 'email' },
      ];

      return {
        getRowValues: formatClientData,
        headers,
      };
    }

    case referral: {
      return {
        getRowValues: formatReferralData,
        headers: [
          { label: 'Recipient', value: 'recipient' },
          { label: 'Client Name', value: 'full_name' },
          { label: 'Sent By', value: 'created_by' },
          { label: 'Service Type', value: 'service_type' },
          { label: 'Status', value: 'status' },
          { label: 'Last Updated', value: 'updated_at' },
        ],
      };
    }

    case servicecase: {
      return {
        getRowValues: formatCaseData,
        headers: [
          { label: 'Client Name', value: 'full_name' },
          { label: 'Program', value: 'program_name' },
          { label: 'Service Type', value: 'service_type' },
          { label: 'Status', value: 'status' },
          { label: 'Primary Worker', value: 'primary_worker' },
          { label: 'Last Updated', value: 'updated_at' },
        ],
      };
    }

    default:
      return {};
  }
}

export default getColumnHeaders;
